import { BreadcrumbBox } from '@/features/Breadcrumb';
import { Button, CaptureClicksRichText, Image, JumplinksContainer } from '@/features/shared';
import { MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { CardContentType } from './CardContent.interface';
import useStyles from './CardContent.style';

const CardContent = ({
  superheading,
  logo,
  headline,
  subheading,
  primaryCTA,
  secondaryCTA,
  alignment,
  theme = Theme.light,
  includeJumplinks,
  contentButtons,
  labels,
}: PropsWithChildren<Br.PropsWithContentButtons<CardContentType>>) => {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <div className={clsx(classes.card, alignment)}>
        <BreadcrumbBox className={classes.breadcrumb} theme={theme} />
        {contentButtons?.content}
        {superheading && (
          <MuiTypography
            data-testid="qa-cta-component-superHeading"
            variant="overline"
            component="h5"
            className={classes.superheading}
          >
            {superheading}
          </MuiTypography>
        )}
        {logo && (
          <div className={classes.logo}>
            <Image image={logo} className={classes.logoImage} />
          </div>
        )}
        {headline && (
          <CaptureClicksRichText
            theme={Theme.light}
            customStyles
            content={headline}
            className={clsx(classes.headline, 'gtm-headline')}
          />
        )}
        {subheading && (
          // <MuiTypography
          //   variant="h5"
          //   component="h2"
          //   dangerouslySetInnerHTML={{ __html: subheading }}
          //   className={classes.subheading}
          // />
          <CaptureClicksRichText
            theme={Theme.light}
            customStyles
            content={subheading}
            className={classes.subheading}
          />
        )}
        {(primaryCTA || secondaryCTA) && (
          <div className={classes.ctas}>
            {primaryCTA && (
              <div className="buttonWrapper">
                <Button link={primaryCTA} theme={Theme.light} className="gtm-hero-cta" />
              </div>
            )}
            {secondaryCTA && (
              <div className="buttonWrapper">
                <Button outlined link={secondaryCTA} theme={Theme.light} className="gtm-hero-cta" />
              </div>
            )}
          </div>
        )}
      </div>
      {includeJumplinks && (
        <div className={`${classes.jumplinks}`}>
          {/* TODO(Luis Sardon): Resource Bundle for Jump to label */}
          <JumplinksContainer title={labels?.jump_to || 'Jump to'} theme={theme} />
        </div>
      )}
    </div>
  );
};

export default memo(CardContent);
